import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions } from 'src/actions';
import { Button } from 'src/components/atoms/Button';
import { SelectWithSearch } from 'src/components/atoms/SelectWithSearch';
import { ReduxState } from 'src/reducers';
import { getIsActiveAction } from 'src/utils/lib';

import styles from 'src/components/routes/modals/AssignOrganizationModal/styles.module.css';

// export type Props = {
//   influencerIds?: string[];
// };

export const AssignOrganizationModal: React.FC = () => {
  const dispatch = useDispatch();

  const [select, setSelect] = useState<string>();

  const onClickCancel = () => dispatch(actions.ui.modal.hide());

  const onChange = (value: string) => {
    dispatch(
      actions.api.organization.getOrganization.started({
        limit: 100,
        search: value,
        page: 1,
      })
    );
  };

  const { organizations, activeActions, influencers } = useSelector(
    ({ organization, currentActiveActions, influencers }: ReduxState) => ({
      organizations: organization.data,
      influencers: influencers.selectedInfluencers,
      activeActions: currentActiveActions.actions,
    })
  );

  const isFetching = getIsActiveAction(activeActions, [
    actions.api.influencers.assignOrg.started.type,
  ]);

  const isDone = getIsActiveAction(activeActions, [
    actions.api.influencers.assignOrg.done.type,
  ]);

  const onCreate = () => {
    //const campaign = campaigns?.find((el: Campaign) => el._id === select);

    dispatch(
      actions.api.influencers.assignOrg.started({
        orgId: select || '',
        influencerIds: influencers || [],
        extra: {
          notificationsParams: {
            content: 'Successfully Added',
            type: 'success',
          },
        },
      })
    );
  };

  const neworganizations = organizations?.map(
    (el: { name: string; _id: string }) => ({
      label: el.name,
      value: el._id,
    })
  );

  useEffect(() => {
    dispatch(
      actions.api.organization.getOrganization.started({
        page: 1,
        limit: 100,
        search: '',
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classNames('shadowLight', styles.container)}>
      <div className={styles.headerBlock}>
        <p className={styles.titleStyle}>Assign organization</p>
      </div>

      <div className={styles.mainBlock}>
        <div className={styles.selectMenuBlock}>
          <SelectWithSearch
            onChange={onChange}
            onSelect={setSelect}
            // defaultValue={campaignId}
            options={neworganizations}
            isDebounce
            dropdownStyle={{ zIndex: 10000 }}
            placeholder={{
              id: 'components.routes.modals.AddOrganization.placeholder',
            }}
          />
        </div>
      </div>

      <div className={styles.footerBlock}>
        <div className={styles.buttonCancelStyle}>
          <Button
            onClick={onClickCancel}
            text={{
              id: 'components.routes.modals.AddCampaignModal.cancelButton',
            }}
            variant="cancel"
          />
        </div>

        <div className={styles.buttonCreateStyle}>
          <Button
            preloader={isFetching}
            successLoader={isDone}
            onClick={onCreate}
            disabled={!select}
            text={{
              id: 'components.routes.modals.AddCampaignModal.okButton',
            }}
            variant="create"
          />
        </div>
      </div>
    </div>
  );
};
